import "../css"

import { Stimulus, Controller } from "./stimulus"

Stimulus.register("btn-group", class extends Controller {
  toggle() {
    this.element.parentNode.querySelectorAll(".btn").forEach(el => el.classList.add("disabled"))
  }
})
